module.exports = __webpack_public_path__ + "img/painPerceptionScale_2_w.2cd47c15.png";